const STORAGE_KEY = 'lighthunt.outreach-attribution.v1';
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
const TOKEN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const CHANNEL = /^[a-z0-9_-]{1,64}$/i;

export interface InvitationAttribution {
  token: string | null;
  channel: string | null;
  capturedAt: number;
}

export function readInvitation(storage: Storage, now = Date.now()): InvitationAttribution | null {
  try {
    const value = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
    if (!value || !Number.isFinite(value.capturedAt) || value.capturedAt > now || now - value.capturedAt > MAX_AGE ||
      (value.token !== null && !TOKEN.test(value.token)) ||
      (value.channel !== null && !CHANNEL.test(value.channel)) || (!value.token && !value.channel)) return null;
    return value;
  } catch { return null; }
}

// Keep the first valid invitation through sign-in redirects. Do not retain arbitrary query text.
export function captureInvitation(search: string, storage: Storage, now = Date.now()): InvitationAttribution | null {
  const previous = readInvitation(storage, now);
  if (previous) return previous;
  const params = new URLSearchParams(search);
  const token = params.get('lh_invite');
  const channel = params.get('lh_channel');
  const value: InvitationAttribution = {
    token: token && TOKEN.test(token) ? token : null,
    channel: channel && CHANNEL.test(channel) ? channel : null,
    capturedAt: now,
  };
  if (!value.token && !value.channel) return null;
  try { storage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch { /* Storage can be unavailable. */ }
  return value;
}

export function clearInvitation(storage: Storage): void {
  try { storage.removeItem(STORAGE_KEY); } catch { /* Attribution must not block authentication. */ }
}
